import React from "react";
import { Navbar, Dropdown } from "react-bootstrap";
import Logout from "../features/Logout";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import SelectBrands from "./SelectBrands";
import SelectYears from "./SelectYears";
import ApiService from "../services/ApiService";
import { store } from "../reducer/Store";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import ImportContactsIcon from '@mui/icons-material/ImportContacts';
import FormRegisterUpdate from "./FormRegisterAndUpdateUser";
import pdfTuto from "../assets/Trade Marketing - Manuel d'utilisation.pdf";
import Utils from "../services/Utils";
import { ToastContainer } from "react-toastify";
const NavbarComponent = () => {
  const { dispatch } = React.useContext(store);
  const [brand, setBrand] = React.useState([]);
  const [year, setYear] = React.useState();
  const [currentPwd, setCurrentPwd] = React.useState("");
  const [pwdConfirm, setPwdConfirm] = React.useState("");
  const [errorPassword, setErrorPassword] = React.useState("");
  const [pwd, setPwd] = React.useState("");
  const [showUpdatePassword, setShowUpdatePassword] = React.useState(false);

  const handleClose = () => {
    setShowUpdatePassword(false);
    setPwdConfirm("");
    setPwd("");
    setErrorPassword("");
    setCurrentPwd("");
  };

  const handleShowUpdatePassword = () => {
    setShowUpdatePassword(true);
  };

  /**
   * Cette fonction récupère les années depuis l'API.
   *
   * Elle effectue une requête à l'API pour récupérer les années disponibles.
   *
   * Elle ajoute chaque année à la liste d'options.
   *
   * Elle met à jour l'état global de la liste des années (SET_LISTYEARS) avec les nouvelles options, triées de manière décroissante.
   *
   * Si l'année actuelle est déjà définie dans le stockage local, elle l'utilise pour mettre à jour l'état global de l'année actuelle (SET_CURRENTYEAR).
   * Sinon, elle utilise l'année actuelle obtenue à partir de la date courante pour mettre à jour l'état global de l'année actuelle.
   *
   * En cas d'erreur, la fonction gère les différents scénarios :
   * - Si l'utilisateur n'est pas authentifié, elle effectue une déconnexion en supprimant les informations de l'utilisateur dans le stockage local.
   */
  const getYears = async () => {
    var options = [];
    ApiService.request({}, "years", "get")
      .then(function (response) {
        response.data.map((year) =>
          options.push({ value: year.id, label: year.name })
        );
        dispatch({
          type: "SET_LISTYEARS",
          payload: options.sort(
            (a, b) => parseInt(b.label) - parseInt(a.label)
          ),
        });

        var date = new Date();
        const actualYear = options.filter(
          (year) => year.label === date.getFullYear().toString()
        )[0];
        if (localStorage.getItem("currentYear")) {
          setYear(JSON.parse(localStorage.getItem("currentYear")));
          dispatch({
            type: "SET_CURRENTYEAR",
            payload: JSON.parse(localStorage.getItem("currentYear")),
          });
        } else {
          localStorage.setItem("currentYear", JSON.stringify(actualYear));
          setYear(actualYear);
          dispatch({
            type: "SET_CURRENTYEAR",
            payload: actualYear,
          });
        }
      })
      .catch(function (error) {
        console.log(error.response.data.message);
        if (error.response.data.message === "Unauthenticated.") {
          localStorage.clear();
          dispatch({ type: "SET_LOGOUT", payload: false });
        }
      });
  };

  /**
   * Cette fonction récupère les marques depuis l'API.
   *
   * Elle vérifie d'abord si les marques sont déjà stockées dans le stockage local.
   * Si c'est le cas, elle les récupère et les ajoute à la liste d'options.
   *
   * Sinon, elle effectue une requête à l'API pour récupérer les marques, puis les ajoute à la liste d'options.
   *
   * Elle met à jour l'état global de la liste des marques (SET_LISTBRANDS) avec les nouvelles options.
   *
   * Si les marques actuelles sont déjà définies dans le stockage local, elle les utilise pour mettre à jour l'état global des marques actuelles (SET_CURRENTBRANDS).
   * Sinon, elle utilise les nouvelles options (à l'exception de la première option "Toutes") pour mettre à jour l'état global des marques actuelles.
   *
   * En cas d'erreur, la fonction gère les différents scénarios :
   * - Si l'utilisateur n'est pas authentifié, elle effectue une déconnexion en supprimant les informations de l'utilisateur dans le stockage local.
   */
  const getBrands = async () => {
    var options = [];
    if (JSON.parse(localStorage.getItem("brands"))) {
      JSON.parse(localStorage.getItem("brands")).map((brand) =>
        ApiService.request({}, "brands/" + brand, "get")
          .then(function (response) {
            options.push({
              value: response.data.id,
              label: response.data.name,
            });
            dispatch({ type: "SET_LISTBRANDS", payload: options });
            if (localStorage.getItem("currentBrands")) {
              setBrand(JSON.parse(localStorage.getItem("currentBrands")));
              dispatch({
                type: "SET_CURRENTBRANDS",
                payload: JSON.parse(localStorage.getItem("currentBrands")),
              });
            } else {
              console.log("ici");
              localStorage.setItem("currentBrands", JSON.stringify(options));
              setBrand(options);
              dispatch({
                type: "SET_CURRENTBRANDS",
                payload: options,
              });
            }
          })
          .catch(function (error) {
            console.log(error);
            if (error.response.data.message === "Unauthenticated.") {
              localStorage.clear();
              dispatch({ type: "SET_LOGOUT", payload: false });
            }
          })
      );
      //dispatch({ type: "SET_LISTBRANDS", payload: options });
    } else {
      ApiService.request({}, "brands", "get")
        .then(function (response) {
          response.data.map((brand) =>
            options.push({ value: brand.id.toString(), label: brand.name })
          );
          options.unshift({ value: "all", label: "Toutes" });
          dispatch({ type: "SET_LISTBRANDS", payload: options });
          if (localStorage.getItem("currentBrands")) {
            setBrand(JSON.parse(localStorage.getItem("currentBrands")));
            dispatch({
              type: "SET_CURRENTBRANDS",
              payload: JSON.parse(localStorage.getItem("currentBrands")),
            });
          } else {
            localStorage.setItem(
              "currentBrands",
              JSON.stringify(options.slice(1))
            );
            setBrand(options.slice(1));
            dispatch({
              type: "SET_CURRENTBRANDS",
              payload: options.slice(1),
            });
          }
        })
        .catch(function (error) {
          console.log(error.response.data.message);
          if (error.response.data.message === "Unauthenticated.") {
            localStorage.clear();
            dispatch({ type: "SET_LOGOUT", payload: false });
          }
        });
    }
  };

  /**
   * Cette fonction permet de mettre à jour le mot de passe de l'utilisateur.
   *
   * @param {Event} e - L'événement de soumission du formulaire.
   *
   * L'utilisateur doit renseigner son mot de passe actuel, son nouveau mot de passe et la confirmation du nouveau mot de passe.
   *
   * La fonction envoie une requête à l'API pour mettre à jour le mot de passe de l'utilisateur.
   *
   * Si la requête est réussie, la fonction ferme la fenêtre modale de mise à jour et affiche une notification de succès.
   *
   * En cas d'erreur, la fonction gère les différents scénarios :
   * - Si l'utilisateur n'est pas authentifié, elle effectue une déconnexion en supprimant les informations de l'utilisateur dans le stockage local.
   * - Si le mot de passe et la confirmation du mot de passe sont différents, elle définit un message d'erreur spécifique.
   * - Sinon, elle définit un message d'erreur indiquant que le mot de passe actuel est incorrect.
   */
  const updateUserPassword = async (e) => {
    e.preventDefault();
    const user = {
      current_password: currentPwd,
      email: JSON.parse(localStorage.getItem("user"))[1],
      password: pwd,
      confirm_password: pwdConfirm,
    };
    ApiService.request(
      user,
      "user-my-password/" + JSON.parse(localStorage.getItem("userId")),
      "put"
    )
      .then(function () {
        handleClose();
        Utils.notifySuccess("Votre mot de passe a bien été mis à jour");
      })
      .catch(function (error) {
        if (error.response.data.message === "Unauthenticated.") {
          localStorage.clear();
          dispatch({ type: "SET_LOGOUT", payload: false });
        }
        if (
          error.response.data.message ===
          "User password different from confirm_password."
        ) {
          setErrorPassword(
            "Les champs mot de passe et la confirmation de mot de passe doivent être identitques."
          );
        } else {
          setErrorPassword("Le mot de passe actuel n'est pas bon.");
        }
      });
  };

  React.useEffect(() => {
    getBrands();
    getYears();
  }, []);

  return (
    <>
      <ToastContainer />
      {showUpdatePassword && (
        <FormRegisterUpdate
          controlFormId="update-password-header"
          registerOrUpdateUser={updateUserPassword}
          show={showUpdatePassword}
          id={JSON.parse(localStorage.getItem("userId"))}
          currentPwd={currentPwd}
          setCurrentPwd={setCurrentPwd}
          pwd={pwd}
          setPwd={setPwd}
          pwdConfirm={pwdConfirm}
          setPwdConfirm={setPwdConfirm}
          handleClose={handleClose}
          errorPassword={errorPassword}
          setErrorPassword={setErrorPassword}
        />
      )}
      <Navbar className="main-header bg-blue-light white" expand="lg">
        <div className="container-fluid d-block">
          <div className="row">
            <div className="col-2 d-none">
              <img
                src="/assets/img/logo/logo-white.svg"
                alt="Pierre Fabre"
                width="250"
                height="75"
                className="img-responsive"
              />
            </div>
            <div className="col-12 col-md-8  px-0 pt-1">
              <Navbar.Brand className="white d-none">
                Univers marque :
              </Navbar.Brand>
              <Navbar.Text>
                <SelectBrands brand={brand} setBrand={setBrand} />
              </Navbar.Text>
            </div>
            <div className="col-6 col-md-2 pt-3 pt-md-1">
              <Navbar.Text>
                <SelectYears year={year} setYear={setYear} />
              </Navbar.Text>
            </div>
            <div className="col-6 col-md-2">
              <Navbar className="justify-content-end">
                <Navbar.Text className="pt-0">
                  <Dropdown className="d-inline-block">
                    <Dropdown.Toggle className="header">
                      <div className="d-flex align-items-center">
                        <AccountCircleOutlinedIcon />
                        {" Bonjour " +
                          JSON.parse(localStorage.getItem("user"))[0] +
                          " "}
                        <KeyboardArrowDownOutlinedIcon />
                      </div>
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="header-profile-menu">
                      <Dropdown.Item onClick={() => window.open(pdfTuto)}>
                        <ImportContactsIcon /> Manuel utilisateur
                      </Dropdown.Item>
                      <Dropdown.Item onClick={handleShowUpdatePassword}>
                        <SettingsOutlinedIcon /> Modifier mon mot de passe
                      </Dropdown.Item>
                      <Dropdown.Item>
                        <Logout />
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </Navbar.Text>
              </Navbar>
            </div>
          </div>
        </div>
      </Navbar>
    </>
  );
};

export default NavbarComponent;
